import React from 'react'

import { makeStyles, ListItemIcon, Box } from '@material-ui/core'

import CustomListItemText from './CustomListItemText'
import ListItemButton from './ListItemButton'

import { ReactComponent as HomeIcon } from '~/assets/landline-internet-filled.svg'
import { ReactComponent as SimCardIcon } from '~/assets/sim-filled.svg'
import { Subscription, SubscriptionType } from '~/customer/model/customer.model'
import LineStatusGroup from '~/ui/components/LineStatusGroup/LineStatusGroup'

const useStyles = makeStyles((theme) => {
  const smallHeight = theme.spacing(12) - 8
  return {
    listItem: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      paddingLeft: theme.spacing(12),
      paddingRight: theme.spacing(10),
      '& .arrow-item': {
        right: `-${smallHeight / 4}px`,
        borderWidth: `${smallHeight / 2}px 0 ${smallHeight / 2}px ${smallHeight / 4}px`,
      },
    },

    listItemIcon: {
      minWidth: theme.spacing(8),
      color: 'inherit',
    },
    icon: {
      color: 'inherit',
    },
  }
})

interface ProductItemProps {
  subscription: Subscription
  className?: string
  onChangeSelected: (itemId: string) => void
  itemId: string
  selectedItemsIds: string[]
}

const ProductItem: React.FC<ProductItemProps> = ({
  subscription,
  className,
  onChangeSelected,
  itemId,
  selectedItemsIds,
}) => {
  const classes = useStyles()

  function getIconSvg(type: SubscriptionType) {
    switch (type) {
      case SubscriptionType.ADSL:
      case SubscriptionType.FFTH:
        return <HomeIcon className={classes.icon} />

      default:
        return <SimCardIcon className={classes.icon} />
    }
  }

  return (
    <ListItemButton
      className={`${className} ${classes.listItem} product-item`}
      selected={selectedItemsIds?.includes(itemId)}
      onClick={() => onChangeSelected(itemId)}
    >
      <ListItemIcon className={classes.listItemIcon}>{getIconSvg(subscription.type)}</ListItemIcon>
      <Box display="flex" flexGrow={1} justifyContent="space-between">
        <CustomListItemText
          primary={subscription.identificationNr}
          primaryTypographyProps={{ variant: 'subtitle2' }}
          data-hook={`product-${subscription.identificationNr}`}
        />
        <LineStatusGroup status={subscription.statusGroup} variant="small" />
      </Box>
    </ListItemButton>
  )
}

export default ProductItem
